// extracted by mini-css-extract-plugin
module.exports = {"btn":"LabeledSwitchingItem_btn__1TLlu","select":"LabeledSwitchingItem_select__1cIr6"};